<template>
   		<!--批量删除界面-->
				<el-tabs v-model="activeName" @tab-click="handleClick" v-loading="delLoading" element-loading-text="正在删除">
					<el-tab-pane label="按号段删卡" name="first" style="margin-top:5px">
					<el-form :model="delForm" ref="delForm" :rules="delFormRules" :inline="true" >
						<el-form-item label="卡号段：" prop="cardFromNo">
							<el-input v-model="delForm.cardFromNo" placeholder="请输入MSISDN"></el-input>
						</el-form-item>
						<el-form-item label="至"  prop="cardToNo">
							<el-input v-model="delForm.cardToNo" placeholder="请输入MSISDN"></el-input>
						</el-form-item>
					</el-form>
					<div style="text-align:right">
						<el-button @click.native="delFormVisible = false">取消</el-button>
						<el-button type="primary" @click.native="batchRemove">删除</el-button>
					</div>
					</el-tab-pane>
					<el-tab-pane label="按号码删卡" name="second">
						<el-input
						type="textarea"
						:rows="15"
						placeholder="请粘贴要删除的卡号列表(每一条一行)"
						v-model="textarea" class="textexport">
						</el-input>
						<div style="text-align:right;margin-top:10px;">
							<el-button @click.native="delFormVisible = false">取消</el-button>
							<el-button type="primary" @click.native="batchDelete" >删除</el-button>
					</div>
					</el-tab-pane>
				</el-tabs>
</template>
<script>
	import util from '../../common/js/util';
	import {  batchRemoveCard,bathDelCards } from '../../api/api';
	export default {
		data() {
			return {				
				textarea:'',
				activeName: 'first',
				delFormVisible: true,//批量删除界面是否显示
				delLoading: false,
				delFormRules: {
					cardFromNo: [
						{ required: true, message: '请输入MSISDN开始号段', trigger: 'blur' }
					],
					cardToNo: [
						{ required: true, message: '请输入MSISDN截至号段', trigger: 'blur' }
					]					
				},
				delForm: {
					cardFromNo: '',
					cardToNo: ''
				},
			}
		},
		methods: {
			//删除切换面板
			handleClick(tab, event) {
				console.log(tab, event);
			},
			//显示批量删除界面
			showBatchDel: function () {
				this.delFormVisible = true;
				this.delForm = {
					cardFromNo: '',
					cardToNo: ''
				};
			},
			//批量删除
			batchRemove: function () {
				this.$refs.delForm.validate((valid) => {
					if (valid) {
						var diffNum = this.delForm.cardToNo - this.delForm.cardFromNo;
						if(diffNum<0){
							this.$message({
							message: "选择的卡号段无效,请重新选择！",
							type: 'error'
							});
							return;
						}
						//var ids = this.sels.map(item => item.id).toString();
						this.$confirm('确认删除选中记录吗？', '提示', {
							type: 'warning'
						}).then(() => {
							this.delLoading = true;
							//NProgress.start();
							let para = { fromCardId: this.delForm.cardFromNo,toCardId: this.delForm.cardToNo };
							batchRemoveCard(para).then((res) => {
								this.delLoading = false;
								//NProgress.done();
              					let { msg, code } = res;
								if (code !== 0) {
									this.$message({
									message: msg,
									type: 'error'
									});
								} else {

									this.$message({
										message: '删除成功'+res.data+'张卡',
										type: 'success'
									});
									this.$refs['delForm'].resetFields();
									this.delFormVisible = false;
									//this.getCards();
								}								
								
							});
						}).catch(() => {

						});


					}
				});

			},
			//根据卡号批量删除
			batchDelete:function(){
				//判断取出左右两边空格后的数据
				var str=this.textarea.trim();
				if(str==""){
					this.$message({
					message: '卡编号不能为空',
					type: 'error'
				});
				}else{

					this.$confirm('确认删除指定记录吗？', '提示', {
							type: 'warning'
						}).then(() => {
					let param={
						cardStr:str
					}
					this.delLoading=true;
					bathDelCards(param).then((res) => {
						this.delLoading=false;
						if(res.code==0){
							this.$message({
								message: res.msg,
								type: 'success'
							});
							this.textarea="";
							this.delFormVisible = false;
							//this.getCards();
						}else{
							this.$message({
								message: res.msg,
								type: 'error'
							});
						}
               			 });
					}).catch(() => {

				});
				}
			}

		}
	}

</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// card_batch_del.vue?b4ed8702